import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { useConnectWalletModal } from 'modules/wallet/ui/ConnectWalletModal'
import { useBorrowModal } from '../../BorrowModal'
import { ReactComponent as BorrowWBTC } from 'assets/borrow.svg'
import { PoolRisk } from 'modules/pools/constants/PoolRisk'
import { Link } from 'shared/ui/controls/Link'
import { PoolAsset } from 'modules/pools/constants/poolAssets'
import * as links from 'modules/router/links'
import { useFirebase } from 'modules/analytics/firebase'
import { BORROW_MARKETS_PAGE_CLICK_EVENT } from 'modules/analytics/events'

import s from './BorrowLink.module.scss'

interface Props {
  poolRisk?: PoolRisk
  asset: PoolAsset
}

export const BorrowLink: React.FC<Props> = ({ asset, poolRisk }) => {
  const { nfcsStatus, risk } = useNFCSState()
  const { isWalletConnected } = useWeb3()
  const borrowModal = useBorrowModal()
  const connectWalletModal = useConnectWalletModal()
  const { trackEvent } = useFirebase()

  const icon = <BorrowWBTC className={s.borrowIcon} />

  const connectToWallet = () => {
    borrowModal.open({
      onContinue: () => {
        connectWalletModal.open({})
      },
    })
  }

  if (!isWalletConnected) {
    return (
      <div className={s.borrowButton} onClick={connectToWallet}>
        {icon}
      </div>
    )
  }

  if (nfcsStatus === 'loading') {
    return null
  }

  if (!poolRisk || nfcsStatus !== 'generated') {
    return (
      <div className={s.borrowButton} onClick={connectToWallet}>
        {icon}
      </div>
    )
  }

  if (risk === poolRisk) {
    return (
      /* TODO: Add pool info to link when pools data will be real */
      <Link
        to={`${links.borrow}?asset=${asset}`}
        onClick={() =>
          trackEvent(BORROW_MARKETS_PAGE_CLICK_EVENT, { risk: poolRisk, asset })
        }
        testId={`markets-page-borrow-link-${asset}-${poolRisk}`}
      >
        {icon}
      </Link>
    )
  }

  return null
}
